<template>
  <div class="expandable-text" data-testid="expandable-text">
    <v-tooltip
      bottom
      content-class="tooltip-bottom"
      open-delay="500"
      :disabled="!showTooltip"
    >
      <template #activator="{ on, attrs }">
        <h5
          ref="textEl"
          v-bind="attrs"
          class="expandable-text__content expandable-text__content--clamped ma-0 font-weight-semibold"
          :class="{ 'expandable-text__content--focusable': showTooltip }"
          :style="clampStyle"
          data-testid="expandable-text__content"
          :tabindex="showTooltip ? 0 : undefined"
          v-on="on"
        >
          {{ text }}
        </h5>
      </template>
      <span data-testid="expandable-text__tooltip">{{ text }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import './ExpandableText.scss';

export default {
  name: 'ExpandableText',

  props: {
    text: {
      type: String,
      default: '',
    },
    lines: {
      type: Number,
      default: 3,
    },
  },

  data() {
    return {
      overflow: false,
    };
  },

  computed: {
    showTooltip() {
      return this.overflow && !!this.text;
    },
    clampStyle() {
      return {
        WebkitLineClamp: String(this.lines),
      };
    },
  },

  watch: {
    text() {
      this.$nextTick(() => this.measureOverflow());
    },
  },

  mounted() {
    this.measureOverflow();
  },

  updated() {
    this.measureOverflow();
  },

  methods: {
    measureOverflow() {
      const el = this.$refs.textEl;
      if (!el) {
        this.overflow = false;
        return;
      }
      this.overflow = el.scrollHeight > el.clientHeight + 1;
    },
  },
};
</script>

<style scoped lang="scss">
.expandable-text__content {
  color: var(--grey-900);
}
</style>
